import { get, post, put } from "./api_helper"

// branches
const getListPage = params => get('admin/master/rtw-image/page', params)
const getDetail = (id) => get(`admin/master/rtw-image/${id}`)
const putData = (par) => put(`admin/master/rtw-image/${par.id}`, par.params)
const postData = params => post(`admin/master/rtw-image`, params)


const RtwImageAPI = {
  getListPage,
  getDetail,
  postData,
  putData,
}

export default RtwImageAPI